export enum LicenseStatus {
  INITIALIZED = "INITIALIZED",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  CANCELLED = "CANCELLED"
}
